import { forwardRef } from 'react'
import { createEvent } from '@trybeapp/ui.utilities'
import { Select } from '@trybeapp/ui.select'
import { useCurrentSiteId } from 'contexts/SiteConfig'
import { useDiscountTypes } from 'api/DiscountTypes'

export const DiscountTypeSelect = forwardRef(({ onChange, returnObject = true, ...props }, ref) => {
  const siteId = useCurrentSiteId()
  const { data: { data: discountTypes = [] } = {}, isSuccess } = useDiscountTypes({
    siteId,
    perPage: -1,
  })

  if (!isSuccess) return null

  const options = discountTypes.map((discountType) => {
    const amount = discountType.amount_type === 'fixed_amount' ? '' : `${discountType.percentage}%`

    let label = discountType.code
      ? `[${discountType.code}] ${discountType.name}`
      : discountType.name

    label += amount ? ` (${amount})` : ''

    return {
      value: discountType.id,
      label,
    }
  })

  return (
    <Select
      options={options}
      ref={ref}
      onChange={(id) =>
        onChange(returnObject ? discountTypes.find((discountType) => discountType.id === id) : id)
      }
      {...props}
    />
  )
})

export const FormikDiscountTypeSelect = forwardRef(
  ({ onChange: parentOnChange, name, ...props }, ref) => {
    const onChange = (value) => {
      parentOnChange(createEvent({ name, value: value.id }))
    }

    return <DiscountTypeSelect name={name} onChange={onChange} ref={ref} {...props} />
  }
)
